/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentSplitDto
 */
export interface PaymentSplitDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentSplitDto
     */
    amount: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitDto
     */
    locationId: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentSplitDto
     */
    commissionAmount?: string | null;
}

/**
 * Check if a given object implements the PaymentSplitDto interface.
 */
export function instanceOfPaymentSplitDto(value: object): value is PaymentSplitDto {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    return true;
}

export function PaymentSplitDtoFromJSON(json: any): PaymentSplitDto {
    return PaymentSplitDtoFromJSONTyped(json, false);
}

export function PaymentSplitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSplitDto {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'locationId': json['locationId'],
        'commissionAmount': json['commissionAmount'] === undefined ? undefined : json['commissionAmount'] === null ? null : json['commissionAmount'],
    };
}

export function PaymentSplitDtoToJSON(json: any): PaymentSplitDto {
    return PaymentSplitDtoToJSONTyped(json, false);
}

export function PaymentSplitDtoToJSONTyped(value?: PaymentSplitDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'locationId': value['locationId'],
        'commissionAmount': value['commissionAmount'],
    };
}

